
import '@/index.css';
import ProfesionalBlock from '@/components/bodyBlocks/profesionalBlock/ProfesionalBlock';

const Profesional = () => {
  /* const { profesional_name, servicio_name } = useParams<{ profesional_name: string, servicio_name: string}>();
 */
  return (
    <div /* style={{ marginTop: '20px'}} */>
      <ProfesionalBlock /* profesional_name={profesional_name || ""} servicio_name={servicio_name || ""} *//>
    </div>
  );
};

export default Profesional;
